<template>
  <aside :data-visible="visible">
    <slot></slot>
    <button type="button" @click.prevent="$emit('close')" :tabindex="!visible && -1">OK</button>
  </aside>
</template>

<script>
  export default {
    props: ['visible']
  }
</script>

<style lang="scss">
  @import '@/assets/_vars.scss';

  aside {
    width: 80%;
    max-width: 20rem;
    max-height: 80%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    box-shadow: 0 1px spacer(2) rgba(black,.5), 0 0 0 100vmax rgba(black,.5);
    background-color: white;
    border-radius: spacer(.5);
    text-align: center;
    padding: spacer(2);
    padding-bottom: spacer();
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
    z-index: 99;
    transition: all 250ms;

    &:not([data-visible]) {
      transform: translate3d(-50%,-50%,0) scale(.9);
      pointer-events: none;
      opacity: 0;
    }

    strong {
      display: block;
      margin-bottom: spacer(.5);
    }

    small {
      display: block;
    }

    button {
      appearance: none;
      display: block;
      width: 100%;
      margin-top: spacer();
      margin-bottom: spacer(-.5);
      padding: spacer();
      color: color('secondaryBlue');
      background: none;
      border: none;
      border-top: 1px solid rgba(black,.1);
      font-weight: bold;
      position: sticky;
      bottom: 0;
      background: white;
    }
  }
</style>
